import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import { useOwner } from '../context/context.js';
import { ProfileModule } from '../ui_items/Module.js';
import ActionButton from '../builder/ActionButton.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import { i18nIntl } from '../../lib/ep.js';
import { isStageOpen } from '../../data/bootstrap_stages.js';

const PremoderationAccess = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const stages = Object.values(props?.stages ?? {});

	const stages_with_premoderation_requirements = stages.filter((s) => {
		return ([1,3].includes(parseInt(s.Stage.reqs_type)) && s.Stage.reqs_premoderation) || s.Stage.reqs_type == 8
	});

	const has_premoderation_requirements = (stages_with_premoderation_requirements.length > 0) ? true : false;
	if(has_premoderation_requirements === false) return null;

	const total = props?.pending_receipts ?? 0;
	const has_tickets = (total > 0) ? true : false;
	const label_receipts = (total == 1) ? "There is {total} purchase receipt pending review." : "There are {total} purchase receipts pending review.";

	const disabled_review = !isStageOpen(stages_with_premoderation_requirements[0].Stage,promotion);

	return (
		<ProfileModule icon={(has_tickets) ? 'ep-exclamation redIcon' : null} title={{ label:"Receipt manual review" }}>
			<p>
				<FormattedMessage
					id={label_receipts}
					values={{ total:(has_tickets) ? <strong class="redColor">{total}</strong> : total }}
				/>
			</p>

			<ButtonCollection>
				<ActionButton
					_class={{ other:'gui_in_end' }}
					_href={`/users/requirements_premoderate/${promotion.id}`}
					autotranslate={false}
				>{disabled_review ? i18n("View", 'ucfirst') : i18n("Review")}</ActionButton>
			</ButtonCollection>
		</ProfileModule>
	);
}

export default injectIntl(PremoderationAccess);